export default __webpack_public_path__ + "static/media/Rafting.91cad6cf.jpg";